import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { GlobalService } from '@core/services/global/global.service';

@Component({
  selector: 'app-message-toast',
  standalone: true,
  imports: [],
  templateUrl: './message-toast.component.html',
  styleUrl: './message-toast.component.css',
})
export class MessageToastComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();

  message: string | null = null;
  type: 'success' | 'error' | 'warning' | null = null;
  private timeoutId: any = null;

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    this.subscribeToToastType();
    this.subscribeToToastMessage();
  }

  private subscribeToToastType(): void {
    this.globalService.toastType$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => (this.type = val));
  }

  private subscribeToToastMessage(): void {
    this.globalService.toastMessage$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((msg) => {
        this.message = msg;
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
          this.globalService.resetToast();
        }, 10000);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
